import Form from 'react-bootstrap/Form'
import type { Currency } from '../../../../types'

export type CurrencyPickerProps = {
    label: string
    currencies: Currency[]
    selected: string[]
    /** Měna, kterou nelze odškrtnout (hlavní měna skupiny). */
    lockedCode?: string
    onChange: (codes: string[]) => void
    helpText?: string
    error?: string
}

/** Výběr povolených měn skupiny. */
export function CurrencyPicker({ label, currencies, selected, lockedCode, onChange, helpText, error }: CurrencyPickerProps) {
    const toggle = (code: string, checked: boolean) => {
        const next = checked ? [...new Set([...selected, code])] : selected.filter((item) => item !== code)
        onChange(next)
    }

    return (
        <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>
            <div className="border rounded p-2" style={{ maxHeight: '12rem', overflowY: 'auto' }}>
                {currencies.map((currency) => {
                    const locked = currency.code === lockedCode
                    return (
                        <Form.Check
                            key={currency.code}
                            type="checkbox"
                            id={`mena-${currency.code}`}
                            checked={locked || selected.includes(currency.code)}
                            disabled={locked}
                            label={`${currency.code} — ${currency.name}`}
                            onChange={(event) => toggle(currency.code, event.target.checked)}
                        />
                    )
                })}
            </div>
            {error && <div className="invalid-feedback d-block">{error}</div>}
            {helpText && !error && <Form.Text className="text-muted">{helpText}</Form.Text>}
        </Form.Group>
    )
}
